var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('froala',{attrs:{"id":_vm.id,"tag":'textarea',"config":_vm.config},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},[_vm._v(_vm._s(_vm.model))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }